import React from "react";
import { useState, useEffect, useCallback, useRef } from "react";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import frame from "../../assets/svg/Frame.svg";
import clock from "../../assets/svg/clock.svg";
import org from "../../assets/svg/org.svg";
import proof from "../../assets/svg/Proof.svg";
import pov from "../../assets/svg/pov.svg";
import meet from "../../assets/svg/meet.svg";
import approval from "../../assets/svg/approval.svg";
import cf from "../../assets/svg/cf.svg";
import cus from "../../assets/svg/cus.svg";
import df from "../../assets/svg/df.svg";
import filt from "../../assets/svg/filt.svg";
import que from "../../assets/svg/que.svg";
import arrow from "../../assets/svg/arrow.svg";
import gtin from "../../assets/svg/gtin.svg";
import gtot from "../../assets/svg/gtot.svg";
import scheule from "../../assets/svg/scheule.svg";
import search from "../../assets/svg/search.svg";
import vector from "../../assets/svg/Vector.svg";
import vectorup from "../../assets/svg/Vector up.svg";
import qr from "../../assets/svg/qr.svg";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import p1 from "../../assets/svg/p1.svg";
import p2 from "../../assets/svg/p2.svg";
import dw from "../../assets/svg/dw.svg";
import pn from "../../assets/svg/pn.svg";
import bu from "../../assets/svg/bu.svg";
import lo from "../../assets/svg/lo.svg";
import ph from "../../assets/svg/ph.svg";
import mail from "../../assets/svg/mail.svg";
import mp from "../../assets/svg/mp.svg";
import ent from "../../assets/svg/ent.svg";
import TopBar from "../topbar/TopBar";
import { get } from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../components/visitor/visitorlist.css";

import {
  checkListFailsUpdateApi,
  gateInApprovedCheckListApi,
  gateOutApi,
  getDepartmentFilterApi,
  getLocationFilterApi,
  queueStatusUpdateApi,
} from "./visitor-api";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import QueueApproveModal from "../modal-dialog/queue-approve-modal";
import UpdateScheduleStatusModal from "../modal-dialog/update-schedule-status-modal";
import CheckListFailedAdminModal from "../modal-dialog/checklist-failed-admin-modal";
import GateOutModal from "../modal-dialog/gate-out-modal";
import DOMPurify from "dompurify";
import GenerateQRModal from "../modal-dialog/generate-qr-modal";
import { useGlobal } from "../../GlobalContext.js";
import PoweredBy from "../common/poweredBy.jsx";
import MultiSelectDropDown from "../common/searchbox/multi-select-dropdown.js";
import Loader from "../common/Loader";

const Visitorlist = () => {
  const {
    visitorCurrentTab,
    setVisitorCurrentTab,
    visitorLocation,
    setVisitorLocation,
    visitorDepartment,
    setVisitorDepartment,
    visitorDateRange,
    setVisitorDateRange,
    visitorGateInRange,
    setVisitorGateInRange,
    visitorGateOutRange,
    setVisitorGateOutRange,
  } = useGlobal();

  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const isFirstRun = useRef(true);
  const styles = {
    pagination: {
      display: "flex",
      listStyle: "none",
      gap: "10px",
      justifyContent: "center",
      padding: "10px",
    },
    pageItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "30px",
      height: "30px",
      padding: "10px",
      border: "1px solid #ddd",
      cursor: "pointer",
      borderRadius: "100px",

      fontSize: "12px",
      fontWeight: 500,
    },
    activePage: {
      backgroundColor: "#6929E2",
      color: "white",
      fontWeight: "bold",
    },
  };
  const [showCustomColumPopup, setShowCustomColumPopup] = useState(false);
  const [listingColumns, setListingColumns] = useState([
    { label: "S.No", status: true, value: "code" },
    { label: "Visitor Name", status: true, value: "visitor_name" },
    { label: "Gate", status: true, value: "gate" },
    { label: "Gate In", status: true, value: "in_time" },
    { label: "Gate Out", status: true, value: "out_time" },
    { label: "Organization", status: true, value: "organization" },
    { label: "Proof", status: true, value: "proof_name" },
    { label: "Purpose of Visit", status: false, value: "visit_purpose" },
    { label: "Meeting Person", status: false, value: "meeting_person_name" },
    { label: "Reporting Person", status: false, value: "responsible_pername" },

    // Newly added date fields
    // {"label": "Registered Date", "status": false, "value": "registered_date"},
    // {"label": "Approved Date", "status": false, "value": "approved_date"},
    // {"label": "Checklist Failed Date", "status": false, "value": "checklist_failed_date"},
    // {"label": "Scheduled Date", "status": false, "value": "scheduled_date"},
    // {"label": "Rejected Date", "status": false, "value": "rejected_date"},
  ]);

  const [isVisible, setIsVisible] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [showQueueApproveModal, setShowQueueApproveModal] = useState(false);
  const [showUpdateScheduleStatusModal, setShowUpdateScheduleStatusModal] =
    useState(false);
  const [showGateOutDetails, setShowGateOutDetails] = useState(false);
  const [showGenerateQRCode, setShowGenerateQRCode] = useState(false);
  const [showChecklistFailedAdminModal, setChecklistFailedAdminModal] =
    useState(false);
  const [visitorDetails, setVisitorDetails] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  //sorting
  const [sortByField, setSortByField] = useState("");
  const [sortBy, setSortBy] = useState("");

  //search
  const [term, setTerm] = useState("");

  // Define button options
  const buttons = [
    { label: "Queue", value: "queue" },
    { label: "Approved", value: "approved" },
    { label: "Checklist Failed", value: "checklist-failed" },
    { label: "Gate In", value: "gatein" },
    { label: "Scheduled", value: "schedule" },
    { label: "Rejected", value: "rejected" },
    { label: "Completed", value: "completed" },
  ];

  // State for active button
  const [activeButton, setActiveButton] = useState(visitorCurrentTab);
  const [approveCount, setApproveCount] = useState(0);
  const [gateInCount, setGateInCount] = useState(0);
  const [schedulesCount, setSchedulesCount] = useState(0);
  const [queueCount, setQueueCount] = useState(0);
  const [checkListCount, setCheckListCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [rejectedCount, setRejectedCount] = useState(0);

  // Button click handler
  const handleButtonClick = (buttonValue) => {
    setActiveButton(buttonValue); // Just update state
    setVisitorCurrentTab(buttonValue);
  };

  //Reset Filter
  const handleReset = () => {
    setLocation("");
    setDepartment([]);
    setDateRange([null, null]);
    setGateInRange([null, null]);
    setGateOutRange([null, null]);
    getListData(term, true);
  };

  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % visitors.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`,
    );
    setItemOffset(event.selected);
  }, []);

  //List
  const [list, setList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // location , department , status
  const location = visitorLocation;
  const setLocation = setVisitorLocation;
  const department = visitorDepartment;
  const setDepartment = setVisitorDepartment;

  // Toggle a department option in/out of the selected list
  const handleDepartmentChange = (option) => {
    setDepartment((prev) => {
      const exists = prev.some((item) => item.value === option.value);
      if (exists) {
        return prev.filter((item) => item.value !== option.value);
      }
      return [...prev, option];
    });
  };

  //date range
  const dateRange = visitorDateRange;
  const setDateRange = setVisitorDateRange;
  const [from_date, to_date] = dateRange;

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formattedFromDate = formatDate(from_date);
  const formattedToDate = formatDate(to_date);

  // State for Gate In date range
  const gateInRange = visitorGateInRange;
  const setGateInRange = setVisitorGateInRange;
  const [from_gate_in, to_gate_in] = gateInRange;

  const formattedFromGateIn = formatDate(from_gate_in);
  const formattedToGateIn = formatDate(to_gate_in);

  // State for Gate Out date range
  const gateOutRange = visitorGateOutRange;
  const setGateOutRange = setVisitorGateOutRange;
  const [from_gate_out, to_gate_out] = gateOutRange;

  const formattedFromGateOut = formatDate(from_gate_out);
  const formattedToGateOut = formatDate(to_gate_out);

  const [data, setData] = useState({
    gateInCount: 0,
    gateOutCount: 0,
    scheduleCount: 0,
    schedulePercentage: 0,
    gateInPercentage: 0,
    gateOutPercentage: 0,
  });

  //const response = await get(apiUrl + "visitors?limit="+itemsPerPage+"&skip="+itemOffset+"&from_gate_in="+from_gate_in+"&to_gate_in="+to_gate_in+"&from_gate_out="+from_gate_out+"&to_gate_out="+to_gate_out+"&department_id="+department+"&location_id="+location+"&fromCreatedDate="+from_date+"&toCreatedDate="+to_date+"&status="+status+"&type="+activeButton).then(async (response) => {

  const [visitors, setVisitors] = useState([]);

  const [locations, setLocations] = useState([]);

  const [departments, setDepartments] = useState([]);
  /* useEffect(() => {
    if(visitorCurrentTab!==""){
      setActiveButton(visitorCurrentTab)
    }
  }, []); */
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getListData(term);
    }, 500); // debounce for 500ms

    return () => clearTimeout(delayDebounce); // cleanup on next keystroke
  }, [term]); // trigger when `term` changes

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    getListData(term); // Keep current search value while sorting
  }, [itemOffset, itemsPerPage, activeButton, sortByField, sortBy]);

  //List Api
  const getListData = async (term, clearFilters = false) => {
    setIsLoading(true);
    setVisitors([]);
    const deptId = clearFilters
      ? ""
      : department.map((item) => item.value).join(",");
    const locId = clearFilters ? "" : location;
    const fDate = clearFilters ? "" : formattedFromDate;
    const tDate = clearFilters ? "" : formattedToDate;
    const fGateIn = clearFilters ? "" : formattedFromGateIn;
    const tGateIn = clearFilters ? "" : formattedToGateIn;
    const fGateOut = clearFilters ? "" : formattedFromGateOut;
    const tGateOut = clearFilters ? "" : formattedToGateOut;
    try {
      const response = await get(
        apiUrl +
          "visitors?limit=" +
          itemsPerPage +
          "&skip=" +
          itemOffset * itemsPerPage +
          "&from_gate_in=" +
          fGateIn +
          "&to_gate_in=" +
          tGateIn +
          "&from_gate_out=" +
          fGateOut +
          "&to_gate_out=" +
          tGateOut +
          "&department_id=" +
          deptId +
          "&location_id=" +
          locId +
          "&fromCreatedDate=" +
          fDate +
          "&toCreatedDate=" +
          tDate +
          "&type=" +
          activeButton +
          "&search=" +
          encodeURIComponent(term) +
          "&sortByField=" +
          sortByField +
          "&sortBy=" +
          sortBy,
      )
        .then(async (response) => {
          if (response.data.status === true) {
            setTotalCount(response.data.total_rec ?? 0);
            setPageCount(response.data.totalPages);
            console.log("hi", response.data.gateInCount);
            setVisitors(response.data.Visitorss);
            setData({
              gateInCount: response.data.gateInCount,
              gateOutCount: response.data.gateOutCount,
              scheduleCount: response.data.scheduleCount,
              schedulePercentage: response.data.schedulePercentage,
              gateInPercentage: response.data.gateInPercentage,
              gateOutPercentage: response.data.gateOutPercentage,
            });
            setApproveCount(response.data.approvedCount ?? 0);
            setGateInCount(response.data.gateInTabCount ?? 0);
            setSchedulesCount(response.data.scheduleTabCount ?? 0);
            setQueueCount(response.data.queueCount ?? 0);
            setCheckListCount(response.data.checkListFailedCount ?? 0);
            setCompletedCount(response.data.completedCount ?? 0);
            setRejectedCount(response.data.rejectedCount ?? 0);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 400) {
            }
          }
        });
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  //filter list api
  const getFilterListData = async () => {
    getListData(term);
  };

  useEffect(() => {
    getLocationFilter();
    getDepartmentFilter();
  }, []);

  /*  useEffect(() => {
     getListData(activeButton); // This will now always get the latest value
   }, [activeButton]); */

  const getLocationFilter = async () => {
    try {
      const response = await getLocationFilterApi();
      if (response.success === true) {
        console.log("Hello", response);
        setLocations(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getDepartmentFilter = async () => {
    try {
      const response = await getDepartmentFilterApi();
      if (response.success === true) {
        console.log("Hello", response);
        setDepartments(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  useEffect(() => {
    if (selectedStatus !== "") {
      setChecklistFailedAdminModal(true);
    }
  }, [selectedStatus]);

  const onApprovedCheckList = async () => {
    setChecklistFailedAdminModal(false);
    checkListFailsUpdate("approve");
  };
  const onRejectedCheckList = () => {
    setChecklistFailedAdminModal(false);
    checkListFailsUpdate("reject");
  };
  const checkListFailsUpdate = async (status) => {
    try {
      const response = await checkListFailsUpdateApi(
        visitorDetails.id,
        status,
        "visitor",
      );
      if (response?.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        getListData(term);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const gateInApprovedCheckList = async (id) => {
    try {
      const response = await gateInApprovedCheckListApi(id, "visitor");
      if (response?.data.status === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.status);
        handleSnackbarShow();
        getListData(term);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const onApproveQueue = async (response) => {
    setShowQueueApproveModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getListData(term);
  };
  const onApproveQueueAndGateIn = async (response) => {
    setShowQueueApproveModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getListData(term);
  };
  const onScheduleStatusSuccess = async (response) => {
    setShowUpdateScheduleStatusModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getListData(term);
  };

  const onProceedGateOut = async (
    itemList,
    selectedCustomer,
    attachments,
    remarks,
  ) => {
    setShowGateOutDetails(false);
    gateOut(itemList);
  };

  const gateOut = async (itemList) => {
    try {
      const response = await gateOutApi({
        visitor_id: visitorDetails.id,
        items: itemList.map((item) => ({
          item_name: DOMPurify.sanitize(item.item_name),
          quantity: DOMPurify.sanitize(item.quantity),
          description: DOMPurify.sanitize(item.description),
        })),
      });
      if (response?.data.status === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.status);
        handleSnackbarShow();
        getListData(term);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const queueStatusUpdate = async (id) => {
    const payload = {
      id: id,
      status: "",
      meeting_person: 0,
      checklists: [],
      queue_status: "Rejected", // Approved, Rejected
      validate_check_list: true, // true, fasle
      check_list_status: "", //pending, approve
      type: "visitor", // pending, approved, rejected
      items: [],
    };
    try {
      const response = await queueStatusUpdateApi(payload);
      if (response.statusCode === 400) {
      } else {
        if (response?.data.status === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.status);
          handleSnackbarShow();
          getListData(term);
        } else {
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const listCount = (menu) => {
    switch (menu) {
      case "Queue":
        return queueCount;
      case "Approved":
        return approveCount;
      case "Checklist Failed":
        return checkListCount;

      case "Gate In":
        return gateInCount;
      case "Scheduled":
        return schedulesCount;
      case "Rejected":
        return rejectedCount;
      case "Completed":
        return completedCount;
      default:
        return 0;
    }
  };

  const isFieldEnabled = (field) => {
    if (activeButton === "queue" && field === "Registered Date") return true;
    if (activeButton === "approved" && field === "Approved Date") return true;
    if (
      activeButton === "checklist-failed" &&
      field === "Checklist Failed Date"
    )
      return true;
    if (activeButton === "schedule" && field === "Scheduled Date") return true;
    if (activeButton === "rejected" && field === "Rejected Date") return true;
    return listingColumns
      .filter(
        (option) =>
          ((activeButton === "queue" ||
            activeButton === "approved" ||
            activeButton === "checklist-failed" ||
            activeButton === "schedule" ||
            activeButton === "rejected") &&
            option.value !== "in_time" &&
            option.value !== "out_time" &&
            option.value !== "responsible_pername") ||
          (activeButton === "checklist-failed" &&
            option.value !== "in_time" &&
            option.value !== "out_time") ||
          (activeButton === "gatein" &&
            option.value !== "out_time" &&
            option.value !== "responsible_pername") ||
          (activeButton === "completed" &&
            option.value !== "responsible_pername"),
      )
      .some((item) => item.status === true && item.label === field);
  };
  const dropdownRef = useRef(null);
  const toggleColumn = (key) => {
    const tempColumn = [...listingColumns];
    const index = listingColumns.findIndex((column) => column.value === key);
    tempColumn[index].status = !tempColumn[index].status;
    setListingColumns(tempColumn);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCustomColumPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div style={{ fontFamily: "Epilogue" }}>
      {showQueueApproveModal && (
        <QueueApproveModal
          fromModule={"Visitor"}
          visitorDetails={visitorDetails}
          onApproveQueue={onApproveQueue}
          onApproveQueueAndGateIn={onApproveQueueAndGateIn}
          onCancel={() => {
            setShowQueueApproveModal(false);
          }}
        />
      )}
      {showUpdateScheduleStatusModal && (
        <UpdateScheduleStatusModal
          visitorId={visitorDetails.id}
          onSuccess={onScheduleStatusSuccess}
          onCancel={() => {
            setShowUpdateScheduleStatusModal(false);
          }}
        />
      )}
      {showChecklistFailedAdminModal && (
        <CheckListFailedAdminModal
          moduleId={visitorDetails.id}
          moduleName={"Visitor"}
          checkList={visitorDetails.checklist ?? []}
          visitorName={visitorDetails.visitor_name}
          organization={visitorDetails.organization}
          visitorPicture={visitorDetails.profilephoto ?? ""}
          isSaveEnable={false}
          isApprovedEnable={selectedStatus === "Approve" ? true : false}
          onApproved={onApprovedCheckList}
          isRejectedEnable={selectedStatus === "Reject" ? true : false}
          onRejected={onRejectedCheckList}
          onCancel={() => {
            setChecklistFailedAdminModal(false);
            setSelectedStatus("");
          }}
        />
      )}
      {showGateOutDetails && (
        <GateOutModal
          moduleName={"Visitor"}
          visitorDetails={visitorDetails}
          onProceed={onProceedGateOut}
          onCancel={() => {
            setShowGateOutDetails(false);
          }}
        />
      )}
      {showGenerateQRCode && (
        <GenerateQRModal
          moduleName={"Visitor"}
          visitorDetails={visitorDetails}
          onCancel={() => {
            setShowGenerateQRCode(false);
          }}
        />
      )}

      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <TopBar currentName="visitor" />
        </div>
        <div style={{ backgroundColor: "#FFFFFF" }}>
          {isVisible && (
            <div
              className="container-auto mt-3 ms-4 me-4 mb-3"
              style={{ fontFamily: "Space Grotesk" }}
            >
              <div className="row align-items-center gx-2">
                {" "}
                {/* Reduced horizontal gap */}
                {/* Summary Heading */}
                <div className="col-md-auto d-flex align-items-center">
                  <span className="fw-bold me-2 text-center text-md-start">
                    Summary of your
                    <br /> overall entries
                  </span>
                  <span className="text-muted">
                    <img src={arrow} alt="Arrow" />
                  </span>
                </div>
                {/* Gate In Card */}
                <div className="col-sm-3" style={{ width: "20%" }}>
                  <div
                    className="card border-1 rounded-3"
                    style={{ borderColor: "#E5E5E5", width: "95%" }}
                  >
                    <div className="card-body d-flex align-items-center p-2">
                      <img src={gtin} alt="Gate In" />
                      <div className="ms-2">
                        <h6 className="mb-0 fw-bold">{data.gateInCount}</h6>
                        <small className="text-muted">Gate in</small>
                      </div>
                      <span
                        className="badge ms-auto mb-3 ms-2"
                        style={{ background: "#f7f8f9", color: "#2C8C53" }}
                      >
                        {data.gateInPercentage}%
                      </span>
                    </div>
                  </div>
                </div>
                {/* Gate Out Card */}
                <div className="col-sm-3 " style={{ width: "20%" }}>
                  <div
                    className="card border-1 rounded-3 "
                    style={{ borderColor: "#E5E5E5", width: "95%" }}
                  >
                    <div className="card-body d-flex align-items-center p-2">
                      <img src={gtot} alt="Gate Out" />
                      <div className="ms-2">
                        <h6 className="mb-0 fw-bold">{data.gateOutCount}</h6>
                        <small className="text-muted">Gate out</small>
                      </div>
                      <span
                        className="badge ms-auto mb-3 ms-2"
                        style={{ background: "#f7f8f9", color: "#2C8C53" }}
                      >
                        {data.gateOutPercentage}%
                      </span>
                    </div>
                  </div>
                </div>
                {/* Scheduled Card */}
                <div className="col-sm-3" style={{ width: "20%" }}>
                  <div
                    className="card border-1 rounded-3 "
                    style={{ borderColor: "#E5E5E5", width: "95%" }}
                  >
                    <div className="card-body d-flex align-items-center p-2">
                      <img src={scheule} alt="Scheduled" />
                      <div className="ms-2">
                        <h6 className="mb-0 fw-bold">{data.scheduleCount}</h6>
                        <small className="text-muted">Scheduled</small>
                      </div>
                      <span
                        className="badge ms-auto mb-3 ms-2"
                        style={{ background: "#f7f8f9", color: "#2C8C53" }}
                      >
                        {data.schedulePercentage}%
                      </span>
                    </div>
                  </div>
                </div>
                {/* Hide Button */}
                <div className="col-auto ms-auto mb-4">
                  <button
                    className="btn btn-light rounded d-flex align-items-center justify-content-center"
                    type="button"
                    onClick={() => setIsVisible(false)}
                    style={{
                      width: "65px",
                      background: "#e2f4e9",
                      color: "#252525",
                      fontSize: "12.5px",
                      height: "24px",
                      gap: "5px",
                      borderRadius: "8px",
                      padding: "4px 12px",
                    }}
                  >
                    Hide
                    <img
                      src={vectorup}
                      alt="Arrow Up"
                      style={{ width: "8px", height: "8px" }}
                    />
                  </button>
                </div>
              </div>
            </div>
          )}

          <div
            className="mt-4 ms-4 me-4"
            style={{
              top: "89px",
              left: "24px",
              gap: "24px",
              fontFamily: "Space Grotesk",
              fontWeight: "500",
              color: "#172B4D",
            }}
          >
            <div>
              <div
                className="d-flex justify-content-between align-items-center mb-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ fontSize: 20, fontWeight: "700" }}>
                  Visitor list
                </div>
                {!isVisible && (
                  <div
                    style={{
                      background: "#e2f4e9",
                      color: "#252525",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "4px 12px",
                      borderRadius: "8px",
                    }}
                  >
                    <button
                      className="btn"
                      style={{
                        fontFamily: "Space Grotesk, sans-serif",
                        fontWeight: "500",
                        fontSize: "12.5px",
                        lineHeight: "100%",
                        letterSpacing: "0%",
                        textTransform: "capitalize",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0",
                      }}
                      onClick={() => setIsVisible(true)}
                    >
                      Show analytics{" "}
                      <img
                        src={vector}
                        style={{
                          width: "8px",
                          height: "8px",
                          marginLeft: "6px",
                        }}
                      />{" "}
                    </button>
                  </div>
                )}
              </div>

              {/* Buttons Section */}
              <Row>
                <Col className="mt-2" sm={12} lg={8}>
                  <div style={{ height: "40px" }}>
                    <div
                      className="d-flex hide-scroll"
                      style={{ width: "100%" }}
                    >
                      {buttons.map(({ label, value }) => (
                        <button
                          key={value}
                          className="btn rounded-3 me-2"
                          onClick={() => handleButtonClick(value)}
                          style={{
                            backgroundColor:
                              activeButton === value ? "#D6ffe6" : "#f8f8f8",
                            border:
                              activeButton === value
                                ? "1px solid #2c8c53"
                                : "none",
                            padding: "10px 16px",
                            borderRadius: "12px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "600",
                            fontSize: "13px",
                            color: "#172B4D",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {label} {"(" + listCount(label) + ")"}
                        </button>
                      ))}
                    </div>
                  </div>
                </Col>
                <Col className="mt-2" sm={12} lg={4}>
                  <div style={{ position: "relative" }}>
                    <div
                      className="hide-scroll"
                      style={{ height: "50px" }}
                      /* style={{

                    overflowX: "auto",
                  }} */
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "max-content",
                        }}
                      >
                        {showInput ? (
                          <div
                            className="input-group rounded-pill me-2"
                            style={{ width: "250px", flexShrink: 0 }}
                          >
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search visitors..."
                              style={{
                                boxShadow: "none",
                                outline: "none",
                                border: "1px solid #dcdfe4",
                              }}
                              onChange={(e) => setTerm(e.target.value)}
                              value={term}
                            />
                            <button
                              className="btn btn-outline-secondary"
                              style={{ borderColor: "#dcdfe4" }}
                              onClick={() => setShowInput(false)}
                            >
                              <img src={search} alt="Search Icon" />
                            </button>
                          </div>
                        ) : (
                          <button
                            className="btn rounded-3 me-2"
                            style={{ borderColor: "#dcdfe4", flexShrink: 0 }}
                            onClick={() => setShowInput(true)}
                          >
                            <img src={search} alt="Search Icon" />
                          </button>
                        )}

                        {/* Sort */}
                        <button
                          className="btn rounded-3 me-2"
                          style={{ borderColor: "#dcdfe4", flexShrink: 0 }}
                        >
                          <img src={df} />
                          <select
                            style={{
                              outline: "none",
                              border: "none",
                              fontFamily: "Epilogue",
                              fontSize: "13px",
                              fontWeight: "600",
                            }}
                            onChange={(e) => {
                              const [field, order] = e.target.value.split(" ");
                              setSortByField(field);
                              setSortBy(order);
                            }}
                          >
                            <option
                              value=""
                              style={{
                                fontFamily: "Epilogue",
                                fontSize: "13px",
                                fontWeight: "500",
                              }}
                            >
                              Default (data created)
                            </option>
                            <option
                              value="gate_visitors.visitor_name asc"
                              style={{
                                fontFamily: "Epilogue",
                                fontSize: "13px",
                                fontWeight: "500",
                              }}
                            >
                              Name (Asc)
                            </option>
                            <option
                              value="gate_visitors.visitor_name desc"
                              style={{
                                fontFamily: "Epilogue",
                                fontSize: "13px",
                                fontWeight: "500",
                              }}
                            >
                              Name (Desc)
                            </option>
                            <option
                              value="gate_visitors.created_at asc"
                              style={{
                                fontFamily: "Epilogue",
                                fontSize: "13px",
                                fontWeight: "500",
                              }}
                            >
                              Date (Oldest)
                            </option>
                            <option
                              value="gate_visitors.created_at desc"
                              style={{
                                fontFamily: "Epilogue",
                                fontSize: "13px",
                                fontWeight: "500",
                              }}
                            >
                              Date (Newest)
                            </option>
                          </select>
                        </button>

                        {/* Customize & Filter */}

                        <button
                          onClick={() => {
                            setShowCustomColumPopup(true);
                          }}
                          className="btn rounded-3 me-2"
                          style={{ borderColor: "#dcdfe4", flexShrink: 0 }}
                        >
                          <img src={cus} /> Customize Table
                        </button>

                        <button
                          className="btn rounded-3"
                          style={{ borderColor: "#dcdfe4", flexShrink: 0 }}
                          data-bs-toggle="offcanvas"
                          data-bs-target="#filterPanel"
                        >
                          <img src={filt} alt="Filter Icon" /> Filter
                        </button>

                        <div
                          className="offcanvas offcanvas-end"
                          // tabIndex="-1"
                          id="filterPanel"
                          aria-labelledby="filterPanelLabel"
                          style={{
                            background: "#F8F9F9",
                            width: "300px",
                            zIndex: 1050,
                          }}
                          data-bs-backdrop="false"
                          data-bs-keyboard="false"
                        >
                          <div className="offcanvas-header">
                            <h5 id="filterPanelLabel">Filters</h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="offcanvas"
                              aria-label="Close"
                            ></button>
                          </div>

                          <div className="offcanvas-body">
                            <form>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  style={{ color: "#172B4D" }}
                                >
                                  Location
                                </label>
                                <select
                                  className="form-select"
                                  style={{ color: "#8790A1" }}
                                  value={location}
                                  onChange={(e) => setLocation(e.target.value)}
                                >
                                  <option value="">-- Select --</option>
                                  {locations.map((location) => (
                                    <option
                                      key={location.value}
                                      value={location.value}
                                    >
                                      {location.label}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  style={{ color: "#172B4D" }}
                                >
                                  Department
                                </label>
                                <MultiSelectDropDown
                                  onDropdownChange={handleDepartmentChange}
                                  placeholder={"-- Select --"}
                                  selectedOption={department}
                                  staticOptions={departments}
                                />
                              </div>

                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  style={{ color: "#172B4D" }}
                                >
                                  Date Range
                                </label>
                                <DatePicker
                                  selectsRange={true}
                                  startDate={from_date}
                                  endDate={to_date}
                                  onChange={(update) => setDateRange(update)}
                                  className="form-control"
                                  placeholderText="Select"
                                />
                              </div>

                              <div className="row mb-3">
                                {/* Gate In Date Range Picker */}
                                <div className="col-6">
                                  <label
                                    className="form-label"
                                    style={{ color: "#172B4D" }}
                                  >
                                    Gate In
                                  </label>
                                  <DatePicker
                                    selectsRange={true}
                                    startDate={from_gate_in}
                                    endDate={to_gate_in}
                                    onChange={(update) =>
                                      setGateInRange(update)
                                    }
                                    className="form-control"
                                    placeholderText="Select"
                                  />
                                </div>

                                {/* Gate Out Date Range Picker */}
                                <div className="col-6">
                                  <label
                                    className="form-label"
                                    style={{ color: "#172B4D" }}
                                  >
                                    Gate Out
                                  </label>
                                  <DatePicker
                                    selectsRange={true}
                                    startDate={from_gate_out}
                                    endDate={to_gate_out}
                                    onChange={(update) =>
                                      setGateOutRange(update)
                                    }
                                    className="form-control"
                                    placeholderText="Select"
                                  />
                                </div>
                              </div>
                            </form>

                            <div className="row p-3 flex justify-content-center mt-5">
                              <button
                                className="col-5 btn rounded-pill me-2"
                                style={{
                                  background: "#FFFFFF",
                                  borderColor: "#E5E5E5",
                                }}
                                onClick={handleReset}
                              >
                                Reset
                              </button>
                              <button
                                className="col-5 btn rounded-pill btn-success"
                                onClick={getFilterListData}
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {showCustomColumPopup && (
                      <div
                        ref={dropdownRef}
                        style={{
                          position: "absolute",
                          top: "40px",
                          right: "-10%",
                          transform: "translateX(-50%)",
                          backgroundColor: "#ffffff",
                          color: "#1E1E1E",
                          padding: "16px",
                          borderRadius: "16px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                          zIndex: 1000,
                          alignItems: "end",
                        }}
                      >
                        <div
                          className="font-semibold mb-2"
                          style={{ fontSize: "18px" }}
                        >
                          Select Columns
                        </div>
                        {listingColumns
                          .filter(
                            (option) =>
                              ((activeButton === "queue" ||
                                activeButton === "approved" ||
                                activeButton === "checklist-failed" ||
                                activeButton === "schedule" ||
                                activeButton === "rejected") &&
                                option.value !== "in_time" &&
                                option.value !== "out_time" &&
                                option.value !== "responsible_pername") ||
                              (activeButton === "checklist-failed" &&
                                option.value !== "in_time" &&
                                option.value !== "out_time") ||
                              (activeButton === "gatein" &&
                                option.value !== "out_time" &&
                                option.value !== "responsible_pername") ||
                              (activeButton === "completed" &&
                                option.value !== "responsible_pername"),
                          )
                          .map((col, index) => (
                            <div key={col.value} className="mb-1">
                              <label>
                                <input
                                  type="checkbox"
                                  checked={col.status}
                                  onChange={() =>
                                    toggleColumn(col.value, index)
                                  }
                                />
                                <span
                                  className="ms-2"
                                  style={{ fontSize: "16px" }}
                                >
                                  {col.label}
                                </span>
                              </label>
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>

            {/* Visitors Table */}
            <div className="table-responsive mt-3">
              <table className="table table-hover border table-bordered align-middle">
                <thead>
                  <tr style={{ fontSize: "13px", textTransform: "capitalize" }}>
                    {isFieldEnabled("S.No") && (
                      <th
                        style={{
                          textAlign: "center",
                          color: "#174b4d",
                          background: "#f8f9f9",
                        }}
                      >
                        S.No
                      </th>
                    )}
                    {isFieldEnabled("Visitor Name") && (
                      <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                        <img src={frame} className="mb-1" /> Visitor Name
                      </th>
                    )}
                    {isFieldEnabled("Gate") && (
                      <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                        <img src={clock} className="mb-1" /> Gate
                      </th>
                    )}

                    {isFieldEnabled("Gate In") && (
                      <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                        <img src={clock} className="mb-1" /> Gate In
                      </th>
                    )}
                    {isFieldEnabled("Gate Out") && (
                      <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                        <img src={clock} className="mb-1" /> Gate Out
                      </th>
                    )}
                    {isFieldEnabled("Organization") && (
                      <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                        <img src={org} className="mb-1" /> Organization
                      </th>
                    )}
                    {isFieldEnabled("Proof") && (
                      <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                        <img src={proof} className="mb-1" /> Proof
                      </th>
                    )}
                    {isFieldEnabled("Purpose of Visit") && (
                      <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                        <img src={pov} className="mb-1" /> Purpose Of Visit
                      </th>
                    )}
                    {isFieldEnabled("Meeting Person") && (
                      <th
                        style={{
                          color: "#174b4d",
                          background: "#f8f9f9",
                        }}
                      >
                        <img src={meet} className="mb-1" /> Meeting Person
                      </th>
                    )}
                    {isFieldEnabled("Reporting Person") && (
                      <th
                        style={{
                          color: "#174b4d",
                          background: "#f8f9f9",
                        }}
                      >
                        <img src={meet} className="mb-1" /> Reporting Person
                      </th>
                    )}
                    {/* {isFieldEnabled("Registered Date") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      Registered Date
                    </th>
                  )}

                  {isFieldEnabled("Approved Date") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      Approved Date
                    </th>
                  )}

                  {isFieldEnabled("Checklist Failed Date") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      Checklist Failed Date
                    </th>
                  )}

                  {isFieldEnabled("Scheduled Date") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      Scheduled Date
                    </th>
                  )}

                  {isFieldEnabled("Rejected Date") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      Rejected Date
                    </th>
                  )} */}
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="100%" className="text-center py-5">
                        <Loader />
                      </td>
                    </tr>
                  ) : visitors.length === 0 ? (
                    <tr>
                      <td colSpan="100%" className="text-center py-5 text-muted">
                        No records found
                      </td>
                    </tr>
                  ) : (
                    visitors.map((visitor, index) => (
                      <tr
                      key={index}
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                      onClick={() => {
                        navigate("/visitor-view", {
                          state: { id: visitor.id },
                        });
                      }}
                      className="table-row no-hover"
                      style={{
                        cursor: "pointer",
                        fontSize: "13px",
                        textTransform: "capitalize",
                        position: "relative", // Ensure TR is positioning parent
                      }}
                    >
                      {isFieldEnabled("S.No") && (
                        <td
                          className="text-center align-middle"
                          style={{
                            position: "static", // Allow child to position relative to TR
                            overflow:
                              hoveredRow === index ? "visible" : "hidden",
                          }}
                        >
                          {itemOffset * itemsPerPage + (index + 1)}

                          {/* Hover Action Buttons - positioned absolutely relative to the ROW */}
                          {hoveredRow === index &&
                            (visitor.schedule_update ||
                              visitor.queue_update ||
                              visitor.checklist_approve ||
                              visitor.gate_in ||
                              visitor.gate_out ||
                              (visitor.in_time &&
                                !visitor.out_time &&
                                visitor.schedule_status !== "Reject")) && (
                              <div className="row-widget">
                                {visitor.schedule_update === true && (
                                  <button
                                    className="btn rounded-3 btn-success btn-sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setVisitorDetails(visitor);
                                      setShowUpdateScheduleStatusModal(true);
                                    }}
                                  >
                                    Update scheduled status
                                  </button>
                                )}

                                {visitor.queue_update === true && (
                                  <div className="style-justify-center">
                                    <div
                                      className="checklist-reject-btn style-justify-center"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setVisitorDetails(visitor);
                                        queueStatusUpdate(visitor.id);
                                      }}
                                    >
                                      Reject
                                    </div>
                                    <div
                                      className="approve-btn style-justify-center px-2"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setVisitorDetails(visitor);
                                        setShowQueueApproveModal(true);
                                      }}
                                    >
                                      Approve
                                    </div>
                                  </div>
                                )}
                                {visitor.checklist_approve === true && (
                                  <div className="style-justify-center">
                                    <div
                                      className="checklist-reject-btn style-justify-center"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setVisitorDetails(visitor);
                                        setSelectedStatus("Reject");
                                      }}
                                    >
                                      Reject
                                    </div>
                                    <div
                                      className="approve-btn style-justify-center"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setVisitorDetails(visitor);
                                        setSelectedStatus("Approve");
                                      }}
                                    >
                                      Approve
                                    </div>
                                  </div>
                                )}

                                {visitor.in_time != null &&
                                  visitor.out_time == null &&
                                  visitor.schedule_status !== "Reject" && (
                                    <div className="">
                                      {/* Generate QR Button */}
                                      <button
                                        className="btn btn-success  rounded-3 btn-sm"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setVisitorDetails(visitor);
                                          setShowGenerateQRCode(true);
                                        }}
                                      >
                                        Generate QR
                                      </button>

                                      {/* Modal Backdrop */}
                                      {showModal && (
                                        <div
                                          className="modal-backdrop fade show"
                                          onClick={() => setShowModal(false)}
                                        ></div>
                                      )}
                                    </div>
                                  )}
                                {visitor.gate_in === true && (
                                  <button
                                    style={{
                                      border: "none",
                                      backgroundColor: "#2C8C53",
                                      color: "#fff",
                                      padding: "6px 16px",
                                      borderRadius: "20px",
                                      cursor: "pointer",
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      display: "flex",
                                      alignItems: "center",
                                      position: "relative",
                                      zIndex: 2,
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      gateInApprovedCheckList(visitor.id);
                                    }}
                                  >
                                    <span className="px-2">Gate In</span>
                                  </button>
                                )}
                                {visitor.gate_out === true && (
                                  <button
                                    className="btn rounded-3 btn-success btn-sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setVisitorDetails(visitor);
                                      setShowGateOutDetails(true);
                                    }}
                                  >
                                    Gate Out
                                  </button>
                                )}
                              </div>
                            )}
                        </td>
                      )}
                      {isFieldEnabled("Visitor Name") && (
                        <td style={{ color: "#172b4d" }}>
                          {visitor.visitor_name}
                        </td>
                      )}
                      {isFieldEnabled("Gate") && (
                        <td style={{ color: "#172b4d" }}>{visitor.gate}</td>
                      )}
                      {isFieldEnabled("Gate In") && (
                        <td style={{ color: "#172b4d" }}>{visitor.in_time}</td>
                      )}
                      {isFieldEnabled("Gate Out") && (
                        <td style={{ color: "#172b4d" }}>{visitor.out_time}</td>
                      )}
                      {isFieldEnabled("Organization") && (
                        <td style={{ color: "#172b4d" }}>
                          {visitor.organization}
                        </td>
                      )}
                      {isFieldEnabled("Proof") && (
                        <td style={{ color: "#172b4d" }}>
                          {visitor.proof_name || "N/A"}
                        </td>
                      )}
                      {isFieldEnabled("Purpose of Visit") && (
                        <td style={{ color: "#172b4d" }}>
                          {visitor.visit_purpose}
                        </td>
                      )}
                      {/* {isFieldEnabled("Registered Date") && (<td>{visitor.queue_date || "-"}</td>)}
                    {isFieldEnabled("Approved Date") && (<td>{visitor.approved_date || "-"}</td>)}
                    {isFieldEnabled("Checklist Failed Date") && (<td>{visitor.check_list_date || "-"}</td>)}
                    {isFieldEnabled("Scheduled Date") && (<td>{visitor.schedule_date || "-"}</td>)}
                    {isFieldEnabled("Rejected Date") && (<td>{visitor.rejected_date || "-"}</td>)} */}

                      {/* Minimized Meeting Person Column */}
                      {isFieldEnabled("Meeting Person") && (
                        <td
                          style={{
                            color: "#172b4d",
                            position: "relative",

                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <span
                            className="btn rounded-pill"
                            style={{
                              backgroundColor: "#f1f2f4",
                              color: "black",
                              padding: "2px 8px",
                              fontSize: "12px",
                              height: "24px",
                              lineHeight: "1.2",
                              position: "relative",
                              zIndex: 2, // Keeps text above row
                            }}
                          >
                            {visitor.meeting_person_name}
                          </span>

                          {/* Buttons Appear OVER the Row on Hover */}
                        </td>
                      )}
                      {isFieldEnabled("Reporting Person") && (
                        <td
                          style={{
                            color: "#172b4d",
                            position: "relative",
                            whiteSpace: "nowrap",
                            overflow:
                              hoveredRow === index ? "visible" : "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <span
                            className="btn rounded-pill"
                            style={{
                              backgroundColor: "#f1f2f4",
                              color: "black",
                              padding: "2px 8px",
                              fontSize: "12px",
                              height: "24px",
                              lineHeight: "1.2",
                              position: "relative",
                              zIndex: 2, // Keeps text above row
                            }}
                          >
                            {visitor.responsible_pername}
                          </span>
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

            {/* <div className="d-flex justify-content-between align-items-center">
            <div>
              <div className="d-flex align-items-center justify-content-start mx-3">
                <span
                  style={{
                    fontFamily: "Epilogue",
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#212129",
                  }}
                >
                  Records per page :
                </span>
                <select
                          className="select3"
                          id="perpage"
                          value={itemsPerPage}
                          onChange={(event) => {
                            setItemsPerPage(event.target.value);
                          }}
                          style={{
                            cursor: "pointer",
                            fontFamily: "Epilogue",
                            fontSize: "14px",
                            fontWeight: "500",
                            lineHeight: "18.9px",
                            color: "#212129",
                            width: "56px",
                            height: "24px",
                            borderRadius: "10px",
                            border: "0.7px solid #E5E5E5",
                            padding: "0 4px",
                            backgroundColor: "#FFFFFF",
                          }}
                        >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>

            <div>
              <div className="">
                <ReactPaginate
                  previousLabel={
                    <img src={lar} className="ar3" alt="previous" />
                  }
                  nextLabel={<img src={rar} className="ar3" alt="next" />}
                  breakLabel={"..."}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div> */}

            {visitors.length > 0 && (
              <Row>
                <Col>
                  <div className="d-flex align-items-center justify-content-start mx-3">
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#212129",
                      }}
                    >
                      Records per page :
                    </span>
                    <select
                      className="select3"
                      id="perpage"
                      value={itemsPerPage}
                      onChange={(event) => {
                        const newItemsPerPage = parseInt(event.target.value);
                        const firstRecordIndex = itemOffset * itemsPerPage;
                        const newPageOffset = Math.floor(
                          firstRecordIndex / newItemsPerPage,
                        );
                        setItemOffset(newPageOffset);
                        setItemsPerPage(newItemsPerPage);
                      }}
                      style={{
                        cursor: "pointer",

                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "18.9px",
                        color: "#212129",
                        width: "56px",
                        height: "24px",
                        borderRadius: "10px",
                        border: "0.7px solid #E5E5E5",
                        padding: "0 4px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </Col>
                <Col>
                  <div className="d-flex justify-content-end">
                    <ReactPaginate
                      previousLabel={
                        <img src={lar} className="ar3" alt="previous" />
                      }
                      nextLabel={<img src={rar} className="ar3" alt="next" />}
                      breakLabel={"..."}
                      pageCount={pageCount + 1}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      forcePage={itemOffset}
                    />
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </div>
      {/*  */}
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Visitorlist;
